export function scrollToSection(href) {
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(href, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
}
